const pl_PL = {
    strings: {},
    pluralize(n) {
        if (n === 1) {
            return 0;
        }
        return 1;
    },
};
pl_PL.strings = {
    addBulkFilesFailed: {
        '0': 'Dodawanie %{smart_count} pliku nie powiodło się z powodu błędu',
        '1': 'Dodawanie %{smart_count} plików nie powiodło się z powodu błędów',
    },
    addedNumFiles: 'Dodano %{numFiles} plik(i)',
    addingMoreFiles: 'Dodawanie kolejnych plików',
    additionalRestrictionsFailed: '%{count} dodatkowe ograniczenia nie zostały spełnione',
    addMore: 'Dodaj więcej',
    addMoreFiles: 'Dodaj więcej plików',
    aggregateExceedsSize: 'Wybrałeś pliki o łącznym rozmiarze %{size}, ale maksymalny dozwolony rozmiar to %{sizeAllowed}',
    allFilesFromFolderNamed: 'Wszystkie pliki z folderu %{name}',
    allowAccessDescription: 'Aby zrobić zdjęcie lub nagrać filmik z użyciem wbudowanego aparatu, zezwól stronie na dostęp do aparatu',
    allowAccessTitle: 'Zezwól na dostęp do aparatu',
    allowAudioAccessDescription: 'Aby nagrać dźwięk, zezwól stronie na dostęp do mikrofonu.',
    allowAudioAccessTitle: 'Zezwól na dostęp do mikrofonu',
    aspectRatioLandscape: 'Przytnij krajobraz (16:9)',
    aspectRatioPortrait: 'Przytnij portret (9:16)',
    aspectRatioSquare: 'Przytnij kwadrat',
    authAborted: 'Uwierzytelnianie przerwane',
    authenticate: 'Połącz',
    authenticateWith: 'Połącz z %{pluginName}',
    authenticateWithTitle: 'Zaloguj się do %{pluginName} aby wybrać pliki',
    back: 'Wstecz',
    browse: 'Wybierz',
    browseFiles: 'Przeglądaj pliki',
    browseFolders: 'Przeglądaj foldery',
    cancel: 'Anuluj',
    cancelUpload: 'Anuluj przesyłanie',
    closeModal: 'Zamknij',
    companionError: 'Połączenie z serwisem nie powiodło się',
    companionUnauthorizeHint: 'Aby wylogować się z konta %{provider}, przejdź pod adres %{url}',
    complete: 'Ukończono',
    compressedX: 'Zapisano %{size} poprzez kompresję obrazów',
    compressingImages: 'Kompresowanie obrazów...',
    connectedToInternet: 'Połączono z Internetem',
    copyLink: 'Skopiuj link',
    copyLinkToClipboardFallback: 'Skopiuj poniższy adres URL',
    copyLinkToClipboardSuccess: 'Link skopiowany do schowka',
    creatingAssembly: 'Przygotowywanie wysyłania...',
    creatingAssemblyFailed: 'Transloadit: Niepowodzenie przy tworzeniu zbioru',
    dashboardTitle: 'Przesyłanie plików',
    dashboardWindowTitle: 'Okno przesyłania plików (Naciśnij ESC aby zamknąć)',
    dataUploadedOfTotal: 'Przesłano %{complete} z %{total}',
    dataUploadedOfUnknown: '%{complete} z nieznanego',
    discardMediaFile: 'Odrzuć plik multimedialny',
    discardRecordedFile: 'Odrzuć nagrany plik',
    done: 'Ukończono',
    dropHereOr: 'Upuść tutaj lub %{browse}',
    dropHint: 'Upuść swoje pliki tutaj',
    dropPasteBoth: 'Upuść pliki tutaj, wklej, albo %{browse}',
    dropPasteFiles: 'Upuść pliki tutaj, wklej, albo %{browse}',
    dropPasteFolders: 'Upuść foldery tutaj, wklej, albo %{browse}',
    dropPasteImportBoth: 'Upuść pliki tutaj, wklej, %{browse} albo zaimportuj z',
    dropPasteImportFiles: 'Upuść pliki tutaj, wklej, %{browse} albo zaimportuj z',
    dropPasteImportFolders: 'Upuść foldery tutaj, wklej, %{browse} albo zaimportuj z',
    editFile: 'Edytuj plik',
    editFileWithFilename: 'Edytuj plik %{file}',
    editImage: 'Edytuj obraz',
    editing: 'Edycja %{file}',
    emptyFolderAdded: 'Z pustego folderu nie zostały dodane żadne pliki',
    encoding: 'Transkodowanie...',
    enterCorrectUrl: 'Niepoprawny URL: Upewnij się, że wprowadzasz bezpośredni adres pliku',
    enterTextToSearch: 'Wpisz tekst, aby wyszukać obrazy',
    enterUrlToImport: 'Wprowadź URL, aby zaimportować plik',
    error: 'Błąd',
    exceedsSize: '%{file} ma rozmiar większy od dozwolonego %{size}',
    failedToFetch: 'Serwis nie mógł przetworzyć podanego linku, zweryfikuj jego poprawność',
    failedToUpload: 'Przesyłanie %{file} nie powiodło się',
    filesUploadedOfTotal: {
        '0': 'wysłano %{complete} z %{smart_count} pliku',
        '1': 'wysłano %{complete} z %{smart_count} plików',
    },
    filter: 'Filtr',
    finishEditingFile: 'Zakończ edycję',
    flipHorizontal: 'Obróć poziomo',
    folderAdded: {
        '0': 'Dodano %{smart_count} plik z folderu %{folder}',
        '1': 'Dodano %{smart_count} plików z folderu %{folder}',
    },
    folderAlreadyAdded: 'Folder "%{folder}" został już dodany',
    generatingThumbnails: 'Generowanie miniaturek...',
    import: 'Importuj',
    importFiles: 'Importuj pliki z:',
    importFrom: 'Importuj z %{name}',
    inferiorSize: 'Ten plik jest mniejszy niż dozwolony rozmiar %{size}',
    loadedXFiles: 'Załadowano %{numFiles} plików',
    loading: 'Ładowanie...',
    logIn: 'Zaloguj się',
    logOut: 'Wyloguj',
    micDisabled: 'Dostęp do mikrofonu odmówiony przez użytkownika',
    missingRequiredMetaField: 'Brak niezbędnych pól metadanych',
    missingRequiredMetaFieldOnFile: 'Brak wymaganych pól metadanych w %{fileName}',
    missingRequiredMetaFields: {
        '0': 'Brak wymaganego pola metadanych: %{fields}.',
        '1': 'Brak wymaganych pól metadanych: %{fields}.',
    },
    myDevice: 'Moje urządzenie',
    noAudioDescription: 'Aby nagrać dźwięk, podłącz mikrofon lub inne urządzenie wejściowe audio',
    noAudioTitle: 'Mikrofon niedostępny',
    noCameraDescription: 'Aby zrobić zdjęcia lub nagrać wideo, podłącz urządzenie kamery',
    noCameraTitle: 'Kamera niedostępna',
    noDuplicates: "Nie można dodać i zduplikować pliku '%{fileName}', już istnieje",
    noFilesFound: 'Nie znaleziono plików',
    noInternetConnection: 'Brak połączenia z Internetem',
    noMoreFilesAllowed: 'Nie można dodać nowych plików: trwa przesyłanie',
    noSearchResults: 'Niestety, brak wyników dla tego wyszukiwania',
    openFolderNamed: 'Otwórz folder %{name}',
    pause: 'Wstrzymaj',
    paused: 'Wstrzymano',
    pauseUpload: 'Wstrzymaj przesyłanie',
    pickFiles: 'Wybierz pliki',
    pickPhotos: 'Wybierz zdjęcia',
    pleaseWait: 'Proszę czekać',
    pluginNameAudio: 'Audio',
    pluginNameBox: 'Box',
    pluginNameCamera: 'Kamera',
    pluginNameDropbox: 'Dropbox',
    pluginNameFacebook: 'Facebook',
    pluginNameGoogleDrive: 'Google Drive',
    pluginNameGoogleDrivePicker: 'Google Drive',
    pluginNameGooglePhotosPicker: 'Google Photos',
    pluginNameInstagram: 'Instagram',
    pluginNameOneDrive: 'OneDrive',
    pluginNameScreenCapture: 'Zrzut ekranu',
    pluginNameUnsplash: 'Unsplash',
    pluginNameUrl: 'Link',
    pluginNameWebdav: 'WebDAV',
    pluginNameZoom: 'Zoom',
    pluginWebdavInputLabel: 'URL WebDAV dla pliku (np. z ownCloud lub Nextcloud)',
    poweredBy: 'Dostarczane przez %{uppy}',
    processingXFiles: {
        '0': 'Przetwarzanie %{smart_count} pliku',
        '1': 'Przetwarzanie %{smart_count} plików',
    },
    recording: 'Nagrywanie',
    recordingLength: 'Długość nagrania %{recording_length}',
    recordingStoppedMaxSize: 'Nagrywanie zatrzymane, ponieważ rozmiar pliku zbliża się do limitu',
    recordVideoBtn: 'Nagrywaj wideo',
    recoveredAllFiles: 'Przywróciliśmy wszystkie pliki. Możesz teraz wznowić przesyłanie.',
    recoveredXFiles: {
        '0': 'Nie udało się w pełni przywrócić 1 pliku. Proszę wybrać go ponownie i wznowić przesyłanie.',
        '1': 'Nie udało się w pełni przywrócić %{smart_count} plików. Proszę wybrać je ponownie i wznowić przesyłanie.',
    },
    removeFile: 'Usuń plik',
    reSelect: 'Wybierz ponownie',
    resetFilter: 'Zresetuj filtr',
    resetSearch: 'Zresetuj wyszukiwanie',
    resume: 'Wznów',
    resumeUpload: 'Wznów przesyłanie',
    retry: 'Ponów próbę',
    retryUpload: 'Ponów przesyłanie',
    revert: 'Resetuj',
    rotate: 'Obróć 90°',
    save: 'Zapisz',
    saveChanges: 'Zapisz zmiany',
    search: 'Szukaj',
    searchImages: 'Szukaj obrazów',
    selectX: {
        '0': 'Wybierz %{smart_count}',
        '1': 'Wybierz %{smart_count}',
    },
    sessionRestored: 'Sesja przywrócona',
    showErrorDetails: 'Pokaż szczegóły błędu',
    signInWithGoogle: 'Zaloguj się przez Google',
    smile: 'Uśmiech!',
    startAudioRecording: 'Rozpocznij nagrywanie dźwięku',
    startCapturing: 'Rozpocznij rejestrowanie ekranu',
    startRecording: 'Rozpocznij nagrywanie wideo',
    stopAudioRecording: 'Zatrzymaj nagrywanie dźwięku',
    stopCapturing: 'Zatrzymaj rejestrowanie ekranu',
    stopRecording: 'Zatrzymaj nagrywanie wideo',
    streamActive: 'Strumień aktywny',
    streamPassive: 'Strumień pasywny',
    submitRecordedFile: 'Prześlij nagrany plik',
    takePicture: 'Zrób zdjęcie',
    takePictureBtn: 'Zrób zdjęcie',
    takeScreenshot: 'Zrób zrzut ekranu',
    unnamed: 'Bez nazwy',
    upload: 'Przesyłanie',
    uploadComplete: 'Przesyłanie ukończone',
    uploadFailed: 'Przesyłanie nie powiodło się',
    uploading: 'Przesyłanie',
    uploadingXFiles: {
        '0': 'Przesyłanie %{smart_count} pliku',
        '1': 'Przesyłanie %{smart_count} plików',
    },
    uploadPaused: 'Przesyłanie wstrzymane',
    uploadStalled: 'Przesyłanie zatrzymane na %{seconds} sekund. Spróbuj ponownie.',
    uploadXFiles: {
        '0': 'Prześlij %{smart_count} plik',
        '1': 'Prześlij %{smart_count} plików',
    },
    uploadXNewFiles: {
        '0': 'Prześlij +%{smart_count} plik',
        '1': 'Prześlij +%{smart_count} plików',
    },
    xFilesSelected: {
        '0': '%{smart_count} plik zaznaczony',
        '1': '%{smart_count} plików zaznaczonych',
    },
    xMoreFilesAdded: {
        '0': 'dodano %{smart_count} plik więcej',
        '1': 'dodano %{smart_count} plików więcej',
    },
    xTimeLeft: '%{time} zostało',
    youCanOnlyUploadFileTypes: 'Możesz przesłać tylko: %{types}',
    youCanOnlyUploadX: {
        '0': 'Możesz wgrać tylko %{smart_count} plik',
        '1': 'Możesz wgrać tylko %{smart_count} plików',
    },
    youHaveToAtLeastSelectX: {
        '0': 'Musisz wybrać przynajmniej %{smart_count} plik',
        '1': 'Musisz wybrać przynajmniej %{smart_count} plików',
    },
    zoomIn: 'Powiększ',
    zoomOut: 'Pomniejsz',
};
// @ts-ignore untyped
if (typeof Uppy !== 'undefined') {
    // @ts-ignore untyped
    globalThis.Uppy.locales.pl_PL = pl_PL;
}
export default pl_PL;
